import { createContext } from 'react';

import { createStore, type Store } from '../../../core/store/store.js';
import { INITIAL_HOVER_STATE } from '../constants.js';
import type { SankeyHoverState } from '../types/sankey-hover.js';

export const SankeyHoverStoreContext = createContext<Store<SankeyHoverState>>(
  createStore<SankeyHoverState>(INITIAL_HOVER_STATE),
);

SankeyHoverStoreContext['displayName'] = 'SankeyHoverStoreContext';
